// extracted by mini-css-extract-plugin
module.exports =  {"header":"t13tueS","title":"OWuVlcl","floating":"dFKzl6U","title-container":"Wg6pf4i","titleContainer":"Wg6pf4i","text-align-center":"uSw1rV5","textAlignCenter":"uSw1rV5"};